module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EIlswO/tc-custom/9781488012648.jpg?1728726194326",
      "alt": "This image is the cover for the book Wild Montana"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wild Montana\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A government agent falls for a beautiful park ranger while searching for a killer in the mountain wilderness in this romantic suspense.")]), _c('br'), _c('br'), _vm._v("Have a former FBI agent and a law enforcement park ranger met their match in the wilds of Montana?"), _c('br'), _c('br'), _vm._v("With a mysterious death to solve in Glacier National Park, Customs and Border Patrol agent Casper Lawrence must come up with motive, means, opportunity—and a killer. If he doesn’t crack this case by the book, the former FBI agent on strike two will be out. Teamed with a beautiful park ranger, the cowboy agent with the gritty past has to trust sexy lone wolf Alexis Finch. But as their investigation takes them through dangerous terrain and an outlaw motorcycle club’s turf, Casper will do anything to keep Alexis—and what they’ve ignited—alive.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Danica Winters\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Danica Winters is a bestselling author who has won multiple awards for writing books that grip readers with their ability to drive emotion through suspense and occasionally a touch of magic.  When she’s not working, she can be found in the wilds of Montana testing her patience while she tries to hone her skills at various crafts (quilting, pottery, and painting are not her areas of expertise).  She always believes the cup is neither half full nor half empty, but it better be filled with wine.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0